import { bootInstance } from "./instance.js";

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".bhgpxrp").forEach(bootInstance);
});
